const LAST_TENANT_ID_KEY = 'vuey:last-tenant-id';
const LAST_TENANT_PATH_KEY = 'vuey:last-tenant-path';

export function isOfflineSession(): boolean {
    return import.meta.client && typeof navigator !== 'undefined' && navigator.onLine === false;
}

export function getStoredTenantId(): string | null {
    if (!import.meta.client) return null;
    const value = window.localStorage.getItem(LAST_TENANT_ID_KEY);
    return value && value.trim().length > 0 ? value.trim() : null;
}

export function setStoredTenantId(tenantId: string | null | undefined) {
    if (!import.meta.client) return;
    const normalized = String(tenantId || '').trim();
    if (!normalized) return;
    window.localStorage.setItem(LAST_TENANT_ID_KEY, normalized);
}

export function getStoredTenantPath(): string | null {
    if (!import.meta.client) return null;
    const value = window.localStorage.getItem(LAST_TENANT_PATH_KEY);
    return value && value.startsWith('/') ? value : null;
}

export function setStoredTenantPath(path: string | null | undefined) {
    if (!import.meta.client) return;
    const normalized = String(path || '').trim();
    if (!normalized.startsWith('/')) return;
    window.localStorage.setItem(LAST_TENANT_PATH_KEY, normalized);
}
